var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagGuam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.98242 29.2282C9.55017 30.9835 12.6552 32.0109 16.0004 32.0109C19.3455 32.0109 22.4505 30.9835 25.0183 29.2282L16.0004 27.8369L6.98242 29.2282Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0183 2.79337C22.4505 1.03805 19.3455 0.0107422 16.0004 0.0107422C12.6552 0.0107422 9.55017 1.03805 6.98242 2.79337L16.0004 4.18468L25.0183 2.79337Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0108C32 10.7165 28.8302 5.39958 25.0179 2.79346H6.98206C2.76687 5.67496 0 10.5196 0 16.0108C0 21.5023 2.76687 26.3467 6.98206 29.2282H25.0179C29.2332 26.3467 32 21.5023 32 16.0108Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0946 26.1105C14.8759 25.923 9.73913 21.4575 9.73913 16.0107C9.73913 10.5639 14.8759 6.09833 15.0946 5.91089L16 5.13477L16.9054 5.91083C17.1241 6.09833 22.2609 10.5638 22.2609 16.0107C22.2609 21.4576 17.1241 25.9231 16.9054 26.1105L16 26.8866L15.0946 26.1105Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.87 16.0108C20.87 11.1412 16.0004 6.96729 16.0004 6.96729C16.0004 6.96729 11.1309 11.1413 11.1309 16.0108C11.1309 17.5005 11.5869 18.9248 12.2195 20.1847H19.7813C20.4139 18.9248 20.87 17.5005 20.87 16.0108Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.87 16.0107C20.87 17.5004 20.4139 18.9247 19.7813 20.1847L16.0004 20.8803L12.2195 20.1847C11.5869 18.9248 11.1309 17.5004 11.1309 16.0107H20.87Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 25.0541C15.9996 25.0541 18.3451 23.0431 19.7805 20.1846H12.2188C13.6541 23.0431 15.9996 25.0541 15.9996 25.0541Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8691 13.228H19.13L15.9996 16.3585L12.8691 13.228Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9561 15.3149H17.043V21.5758H14.9561V15.3149Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGuam);
export default __webpack_public_path__ + "static/media/flag_guam.40b6a70b471cde87df8c625979a1f4cc.svg";
export { ForwardRef as ReactComponent };